import { refs } from './getRefs';
import { showSaved } from './addToLibrary';

refs.jsLibrary.addEventListener('click', showSaved);
